module.exports = __webpack_public_path__ + "img/logo_2.4973672c.png";